"use client";

import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import agent from "../../../public/agent-img.png";
import call from "../../../public/call.png";
import star from "../../../public/star-glow.png";
import agentImage from "../../../public/Pic.jpg";
import AgentDetails from "@/components/AgentDetails";

interface Question {
  title: string;
  answers: number;
  following: number;
  avatar: string;
}

export default function Component() {
  const [activeTab, setActiveTab] = useState("recently-answered");

  const locations = [
    {
      name: "Central Business District",
      queries: "1000 Queries and Insights",
      color: "bg-[#121212]",
    },
    {
      name: "Orchard Road",
      queries: "173 Queries and Insights",
      color: "bg-[#0094FF]",
    },
    {
      name: "Jurong East",
      queries: "357 Queries and Insights",
      color: "bg-[#121212]",
    },
    {
      name: "Punggol",
      queries: "200 Queries and Insights",
      color: "bg-[#0094FF]",
    },
    {
      name: "Tampines",
      queries: "280 Queries and Insights",
      color: "bg-[#121212]",
    },
    {
      name: "Woodlands and Yishun",
      queries: "450 Queries and Insights",
      color: "bg-[#0094FF]",
    },
  ];

  const questions: Question[] = [
    {
      title: "What makes Singapore's property market unique?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "Which areas in Singapore are best for property investment?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What is the Central Business District (CBD) known for?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "Are there affordable residential areas in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What are the current property trends in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "Which areas are suitable for expatriates in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What is the government's role in property regulation?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "Is renting a popular option in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What is the future outlook for Singapore's property market?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What are the benefits of living in suburban areas like Tampines?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title:
        "How do public housing (HDB) and private housing differ in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "What are some popular luxury property areas in Singapore?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title: "Are there opportunities for commercial property investment?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
    {
      title:
        "What are the transportation advantages in Singapore's property areas?",
      answers: 2,
      following: 3,
      avatar: "/faq-profile.png",
    },
  ];

  const openWhatsApp = () => {
    const phoneNumber = "6588772688"; // Without '+'
    const message = encodeURIComponent(
      "Hi Winnie Lim, I am interested in your property listing."
    );

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className=" ">
      <div className="container mx-auto md:px-8 px-4 py-8">
        <h1 className="text-2xl font-bold mb-8">
          Community Q&A Discussion Forums
        </h1>

        {/* Search Section */}
        <div className="bg-[#121212] rounded-3xl md:px-[230px] py-4 sm:p-8 mb-12">
          <div className="flex flex-col sm:flex-row gap-4 border rounded-full bg-white">
            <input
              type="text"
              placeholder="GOT QUESTIONS? THE LOCALS HAVE ANSWERS!"
              className="flex-1 rounded-full px-6 py-3 text-sm w-full bg-transparent outline-none"
            />
            <button className="bg-[#0094FF] text-white rounded-full px-8 py-3 font-medium hover:bg-[#0080E0] w-full sm:w-auto">
              ASK QUESTION
            </button>
          </div>
        </div>

        {/* Properties in Spotlight */}
        <div className="mb-12">
          <h2 className="text-xl font-bold mb-6">
            Properties in the Spotlight !
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {locations.map((location, index) => (
              <div
                key={index}
                className={`${location.color} text-white rounded-2xl p-6`}
              >
                <h3 className="font-medium text-[20px] mb-2">
                  {location.name}{" "}
                </h3>
                <p className="text-[18px] opacity-90">{location.queries}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:grid md:grid lg:grid-cols-3 md:grid-cols-2 flex flex-col gap-8">
          {/* Questions Section */}
          <div className="lg:col-span-2">
            <h2 className="text-[22px] font-bold mb-7">
              Latest Responses in Orchard Road
            </h2>

            {/* Tabs */}
            <div className="flex flex-wrap gap-2 mb-6">
              <button
                onClick={() => setActiveTab("recently-answered")}
                className={`px-4 py-2 rounded-full text-sm${
                  activeTab === "recently-answered"
                    ? "bg-tranparent text-[#0094FF]  border border-[#0094FF] "
                    : "bg-transparent text-[#0B0B0B] border border-[#0B0B0B]"
                }`}
              >
                Recently Answered
              </button>
              <button
                onClick={() => setActiveTab("recently-asked")}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeTab === "recently-asked"
                    ? "bg-tranparent text-[#0094FF]  border border-[#0094FF] "
                    : "bg-transparent text-[#0B0B0B] border border-[#0B0B0B]"
                }`}
              >
                Recently Asked
              </button>
              <button
                onClick={() => setActiveTab("unanswered")}
                className={`px-4 py-2 rounded-full text-sm ${
                  activeTab === "unanswered"
                    ? "bg-tranparent text-[#0094FF]  border border-[#0094FF] "
                    : "bg-transparent text-[#0B0B0B] border border-[#0B0B0B]"
                }`}
              >
                Unanswered
              </button>
            </div>

            {/* Questions List */}
            <div className="space-y-4">
              {questions.map((question, index) => (
                <div key={index} className="flex items-start gap-4">
                  <Image
                    src={question.avatar}
                    alt="User avatar"
                    width={70}
                    height={70}
                    className="rounded-full flex-shrink-0"
                  />
                  <div className="flex-grow min-w-0">
                    <Link
                      href="#"
                      className="text-[#0094FF] hover:underline block truncate text-[22px]"
                    >
                      {question.title}
                    </Link>
                    <div className="text-[18px] text-[#3A3A3A] mt-1">
                      {question.answers} answers {question.following} following
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center gap-2 mt-8 flex-wrap bg-[#E6F4FF] md:w-max m-auto px-6 py-4 rounded-full custom-shadow-2">
              <button className="w-8 h-8 font-semibold flex items-center justify-center rounded-full text-[#3A3A3A]">
                {"<"}
              </button>
              {[1, 2, 3, 4, 5, 6].map((page) => (
                <button
                  key={page}
                  className={`w-8 h-8 flex items-center justify-center rounded-full ${
                    page === 1 ? "bg-[#121212] text-white" : ""
                  }`}
                >
                  {page}
                </button>
              ))}
              <span className="px-2">...</span>
              <button className="w-8 h-8 flex items-center justify-center rounded-full">
                20
              </button>
              <button className="w-8 h-8 font-semibold flex items-center justify-center rounded-full text-[#3A3A3A]">
                {">"}
              </button>
            </div>
          </div>

          {/* Agents Section */}
          {/* <div className="bg-white rounded-[20px] border border-[#A3A0B7] h-max">
            <div className="p-5">
              <div className="flex items-center gap-3 mb-4">
                <Image
                  src={agentImage}
                  alt="Agent"
                  width={80}
                  height={80}
                  className="rounded-full"
                />
                <div>
                  <h3 className="font-medium text-[16px] leading-[20px]">
                    Winnie Lim æž—æ…§å¦®
                  </h3>
                  <p className="text-[#3A3A3A] text-[14px]">
                    Senior Marketing Director
                  </p>
                </div>
              </div>
              <p className="text-[#3A3A3A] text-[18px] leading-[30px] mb-6">
                Excellent service from the very start. I got valuable advice in
                terms of deciding the best time to put the property.
              </p>
              <div className="flex items-center gap-3 mb-6">
                <button
                  className="flex-1 px-3 py-1.5 text-[14px] rounded-full border border-gray-300 hover:bg-gray-50"
                  onClick={openWhatsApp}
                >
                  Contact Agent
                </button>
                <a
                  href="tel:+6588772688"
                  className="h-9 w-9 rounded-full bg-[#E6F4FF] flex items-center justify-center"
                >
                  <Image src={call} alt="Call" />
                </a>
              </div>
            </div>
            <div className="py-4 text-[22px] text-[#121212]  text-center bg-[#E9E8ED]  overflow-hidden rounded-b-[20px] hover:bg-[#E6F4FF]">
              ERA Realty Network Pte Ltd
            </div>
          </div> */}
          <AgentDetails />
        </div>
      </div>
    </div>
  );
}
